import { render, staticRenderFns } from "./About.vue?vue&type=template&id=416d43cb&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=416d43cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d43cb",
  null
  
)

export default component.exports